export enum ToastType {
  Success,
  Error,
  Info,
}
